module.exports = "<div gw-pl-dropdown=\".<%= dropdown__contentWrap %>\" class=\"<%= dropdown__target %>\" ng-transclude=\"target\"></div>\r\n<div class=\"<%= dropdown__contentWrap %>\">\r\n    <div class=\"<%= dropdown__content %>\" ng-transclude=\"content\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/dropdown/directives/gw-dropdown/gw-dropdown-directive.html
// module id = 910
// module chunks = 0